export default __webpack_public_path__ + "static/object-tile-smaller-do-85847f9e7384891e512fc02a46d2369a3a5729351f17b23f2db97ac181ab19ba.png";